import React from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { trpc } from "@editor/utils/trpc";

import { toast } from "@replo/design-system/components/alert/Toast";
import Button from "@replo/design-system/components/button/Button";

export const DeployButton = () => {
  // TODO (Gabe 2025-05-07): these toasts don't work pressumably the provider is
  // missing on the shops route.
  const { mutate: deploy } = trpc.nextGen.deploy.useMutation({
    onSuccess: () => {
      // console.log("success");
      toast({
        header: "Success",
        message: "Next.js app deployed successfully",
      });
    },
    onError: (error) => {
      // console.error(error);
      toast({
        header: "Error",
        message: error.message,
      });
    },
  });
  const projectId = useCurrentProjectId();
  return (
    <Button
      variant="secondary"
      size="base"
      onClick={() => {
        if (!projectId) {
          return;
        }
        deploy({ projectId });
      }}
    >
      Deploy Next.js app
    </Button>
  );
};
